import { render, staticRenderFns } from "./zoneDetail.vue?vue&type=template&id=195661ca&scoped=true"
import script from "./zoneDetail.vue?vue&type=script&lang=js"
export * from "./zoneDetail.vue?vue&type=script&lang=js"
import style0 from "./zoneDetail.vue?vue&type=style&index=0&id=195661ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195661ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('195661ca')) {
      api.createRecord('195661ca', component.options)
    } else {
      api.reload('195661ca', component.options)
    }
    module.hot.accept("./zoneDetail.vue?vue&type=template&id=195661ca&scoped=true", function () {
      api.rerender('195661ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/logistics/company/csgAdmin/zone/components/zoneDetail.vue"
export default component.exports